"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.decimalNumber = exports.DISPLAY_ATTRIBUTES = void 0;
var DISPLAY_ATTRIBUTES = ['badge', 'color', 'content', 'cover', 'description', 'excerpt', 'finishers', 'goal', 'hashtag', 'highlight', 'highlightBackgroundImage', 'highlightCta', 'indexCover', 'moneyMultiplier', 'objective', 'participants', 'rewardConditions', 'rewardCover', 'rewardName', 'slug', 'title', 'type'];
exports.DISPLAY_ATTRIBUTES = DISPLAY_ATTRIBUTES;
var decimalNumber = 2;
exports.decimalNumber = decimalNumber;
var _default = {
  DISPLAY_ATTRIBUTES: DISPLAY_ATTRIBUTES
};
exports["default"] = _default;
//# sourceMappingURL=constants.js.map